import * as React from 'react'
import { ArrowBigLeft, ArrowBigLeftDash, ArrowBigRight, ArrowBigRightDash } from 'lucide-react'

import cn from '@config/tailwind/cn'

import { Button } from '../components'
import { typographyVariants } from './typography'

interface WeekChangerProps {
  handleClickLeft: () => void
  handleClickFarLeft: () => void
  handleClickRight: () => void
  handleClickFarRight: () => void
  disabledFarLeft: boolean
  disabledFarRight: boolean
  disabledLeft: boolean
  disabledRight: boolean
  /** Primary label, e.g. "Minggu ini". */
  text: string
  /** Secondary line below the label, e.g. the date range "12/08/24 - 18/08/24". */
  subText?: string
  className?: string
}

export function WeekChanger({
  handleClickLeft,
  handleClickFarLeft,
  handleClickRight,
  handleClickFarRight,
  disabledFarLeft,
  disabledFarRight,
  disabledLeft,
  disabledRight,
  text,
  subText,
  className,
}: WeekChangerProps) {
  return (
    <section
      className={cn('ui:w-fit ui:h-fit ui:flex ui:items-center ui:justify-center ui:gap-x-4 ui:flex-wrap', className)}
    >
      <section className='ui:w-fit ui:h-fit ui:flex ui:items-center ui:justify-center ui:gap-x-6'>
        <Button
          variant='ghost'
          className='ui:w-fit ui:h-fit ui:p-0'
          onClick={handleClickFarLeft}
          disabled={disabledFarLeft}
        >
          <ArrowBigLeftDash className='ui:w-6 ui:h-6 ui:text-neutral-black' />
        </Button>

        <Button variant='ghost' className='ui:w-fit ui:h-fit ui:p-0' onClick={handleClickLeft} disabled={disabledLeft}>
          <ArrowBigLeft className='ui:w-6 ui:h-6 ui:text-neutral-black' />
        </Button>
      </section>

      <div className='ui:shrink-0 ui:flex ui:flex-col ui:items-center ui:justify-center ui:text-center ui:text-neutral-black'>
        <p className={cn(typographyVariants({ variant: 'title-sm' }))}>{text}</p>
        {subText && <p className={cn(typographyVariants({ variant: 'body-sm' }))}>{subText}</p>}
      </div>

      <section className='ui:w-fit ui:h-fit ui:flex ui:items-center ui:justify-center ui:gap-x-6'>
        <Button
          variant='ghost'
          className='ui:w-fit ui:h-fit ui:p-0'
          onClick={handleClickRight}
          disabled={disabledRight}
        >
          <ArrowBigRight className='ui:w-6 ui:h-6 ui:text-neutral-black' />
        </Button>

        <Button
          variant='ghost'
          className='ui:w-fit ui:h-fit ui:p-0'
          onClick={handleClickFarRight}
          disabled={disabledFarRight}
        >
          <ArrowBigRightDash className='ui:w-6 ui:h-6 ui:text-neutral-black' />
        </Button>
      </section>
    </section>
  )
}
